import { Http, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { UserService } from '../api/user.service';

@Injectable()
export class HttpInterceptor extends Http {

  constructor(
    backend: XHRBackend,
    options: RequestOptions,
    public http: Http,
    public router: Router,
    public userService: UserService,
    // private spinner: NgxSpinnerService,
  ) {
    super(backend, options);
  }

  public request(url: Request, options?: RequestOptionsArgs): Observable<Response> {
    // this.spinner.show();
    url.headers.set('authorization', 'bearer ' + this.userService.getToken());
    return super.request(url, options)
      .catch(this.handleError)
      .do((res: Response) => {

      }, (error: any) => {

      })
      .finally(() => {
        // this.spinner.hide();
      });
  }

  public handleError = (error: Response) => {
    const router = this.router;
    if (error.status === 0) {
      alert('서버와 연결할 수 없습니다.');
    } else if (error.status === 401) {
      this.userService.logout();
      alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
      this.router.navigate(['/login']);
    } else {
      let errorMessage = error.json().error_description;
      if (errorMessage == null || errorMessage.length < 1) {
        errorMessage = '오류가 발생했습니다.';
      }
      alert(errorMessage);
    }

    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/interceptor/http-interceptor.ts